import { Snackbar } from '@mui/material';
import clsx from 'clsx';
import React, { useState } from 'react';
import { Icon, IconButton } from '@hevoio/hevo-ui-toolkit';

export function LegalNotificationSnackbar() {
  const [open, setOpen] = useState(true);

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={open}
      classes={{
        root: 'flex-no-wrap'
      }}
      message={
        <div className='d-flex text-body-1 flex-no-wrap' style={{ maxWidth: '800px' }}>
          <div className=''>
            <span>
              <span data-text='true'>
                Hevo has updated its{' '}
                <a
                  href='https://hevodata.com/legal-resources/#privacy/customers'
                  target='_blank'
                  rel='noopener'
                >
                  <span>
                    <span data-text='true' className='text-link text-primary'>
                      Privacy Policy
                    </span>
                  </span>
                </a>{' '}
                and{' '}
                <a href='https://hevodata.com/legal-resources/#dpa' target='_blank' rel='noopener'>
                  <span>
                    <span data-text='true' className='text-link text-primary'>
                      DPA
                    </span>
                  </span>
                </a>
                . We encourage you to review these updates as described on our{' '}
              </span>
            </span>
            <a href='https://hevodata.com/legal-resources/' target='_blank' rel='noopener'>
              <span>
                <span data-text='true' className='text-link text-primary'>
                  Legal Resources page.
                </span>
              </span>
            </a>
            <span data-offset-key='ain11-2-0'>
              <span data-text='true'>
                By continuing to use our services on or after Oct 31, 2025, you agree to the
                updated terms.
              </span>
            </span>
          </div>
          <IconButton
            disableRipple
            color='inherit'
            className={clsx('ml-2 p-1')}
            label={''}
            dataId={''}
            onClick={() => {
              setOpen(false);
            }}
          >
            <Icon name='close' />
          </IconButton>
        </div>
      }
      key={'bottom' + 'center'}
    />
  );
}
